// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  name: 'DEVELOP',
  production: false,
  rememberMe: true,
  secret: 'basic',
  pageSizes: [25, 50, 100, 500],
  InterceptorSkipHeader: 'X-Skip-Interceptor',
  apiUrl: 'https://bludotapidev.quinns.pw/',
  dcSpacesUrl: 'https://bludot.ams3.digitaloceanspaces.com/dev/',
  toolkitApi: 'https://toolkit-api.bludot.cloud/v1/',
  paymentsApi: 'https://payments.dev.bludotapi.com/',
  toolkitPortal: 'https://toolkit.bludot.cloud/',
  toolkitHeader: 'app-key',
  toolkitKey: '4c8b3bc3-1e43-4cb7-8918-44e0f754b3a1',
  keys: {
    accessToken: 'basic_token',
    username: 'basic_u',
    password: 'basic_p',
  },
  stripe: {
    client_id: 'ca_BYU25XxrdgPeh8vtmpHzG88wb2afkJoo', // test
    // client_id: 'ca_BYU2l8FSsIVUf6pvkigdVW7xfMICPJHs', // live
    redirect_uri: 'http://localhost:4200/stripe',
  },
  stripeOther: {
    pkLive: 'pk_live_psDOKSORZBKnMtTXQ2TkbcTn',
    pkTest: 'pk_test_WupcZTroMgt74zi6V6SU6BaG',
    skLive: 'sk_live_u5MjbIhnNQ9PoBccpRReUQyi',
    skTest: 'sk_test_Qzb1vAVrIQymdaud3HGbiB4b',
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts